module.exports = __webpack_public_path__ + "static/media/microActive.2e13615c.svg";